<template>
	<span>
		<svg
			width="10"
			height="11"
			viewBox="0 0 10 11"
			fill="none"
			:class="additionalClasses"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_906_6421)">
				<path
					d="M2.7221 1.66203C2.42597 1.92398 2.42597 2.34713 2.7221 2.60908L5.66819 5.21514L2.7221 7.82121C2.42597 8.08316 2.42597 8.50631 2.7221 8.76826C3.01822 9.03021 3.49658 9.03021 3.79271 8.76826L7.2779 5.68531C7.57403 5.42336 7.57403 5.00021 7.2779 4.73826L3.79271 1.65531C3.50418 1.40008 3.01822 1.40008 2.7221 1.66203Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_906_6421">
					<rect
						width="10"
						height="10"
						fill="white"
						transform="translate(0 0.214722)"
					/>
				</clipPath>
			</defs>
		</svg>
	</span>
</template>

<script>
export default {
	name: "ArrowRight",
	props: {
		additionalClasses: {
			type: String,
			default: "text-primary-blue",
		},
	},
};
</script>
